import IState from '@models/IState';

export default (state: IState) => {
    state.enabled = false;
};
